import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Empty, List, Space, Spin, Tag, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { listApprentices } from "./api";
import ApprenticeWeeks from "./ApprenticeWeeks";
import "../safety/safety.css";

/**
 * /user/berichtsheft for everyone with a training record: the apprentice's own weeks, and the
 * apprentices someone trains. The server returns only what the user may see.
 */
const Berichtsheft = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState(null);

  useEffect(() => {
    listApprentices()
      .then(res => setData(res.data.data))
      .catch(error => {
        setData([]);
        if (error?.response?.status !== 403) generalErrorAlert(error);
      });
  }, []);

  if (!data) {
    return (
      <div className="apprenticeship-page sf-center">
        <Spin />
      </div>
    );
  }

  const own = data.find(a => a.relation === "self");
  const trainees = data.filter(a => a.relation !== "self");

  if (!own && !trainees.length) {
    return (
      <div className="apprenticeship-page">
        <Card>
          <Empty description={t("There is no training record for you.")} />
        </Card>
      </div>
    );
  }

  return (
    <div className="apprenticeship-page">
      {own && (
        <>
          <Typography.Title level={4}>{t("My training record")}</Typography.Title>
          <ApprenticeWeeks apprenticeId={own._id} embedded />
        </>
      )}
      {trainees.length > 0 && (
        <Card size="small" title={t("Apprentices")} className="mt-3">
          <List
            dataSource={trainees}
            renderItem={a => (
              <List.Item>
                <Space wrap>
                  <Link to={`/user/berichtsheft/apprentices/${a._id}`}>{a.name}</Link>
                  <span className="sf-small">{a.trade}</span>
                  {a.toReview > 0 && (
                    <Tag color="processing">{t("{{n}} to review", { n: a.toReview })}</Tag>
                  )}
                  {a.missing > 0 && (
                    <Tag color="error">{t("{{n}} weeks missing", { n: a.missing })}</Tag>
                  )}
                </Space>
              </List.Item>
            )}
          />
        </Card>
      )}
    </div>
  );
};

export default Berichtsheft;
